import {Injectable} from "@angular/core";

@Injectable()
export class GAEventService {

    private timings:Map<string, number> = new Map<string, number>();

    public emitEvent(eventCategory: string,
                     eventAction: string,
                     eventLabel: string = null,
                     eventValue: number = null) {
        // @ts-ignore
      ga('send', 'event', {
            eventCategory: eventCategory,
            eventLabel: eventLabel,
            eventAction: eventAction,
            eventValue: eventValue
        });
    }

    public emitTiming(eventCategory: string,
                     eventAction: string,
                     eventLabel: string = null,
                     eventValue: number = null) {

        // @ts-ignore
      ga('send', 'timing', eventAction, eventLabel, eventValue);

    }

    public startDurationEvent(eventCategory: string,
                              eventAction: string,
                              eventLabel:string) {
        this.timings.set(eventCategory + eventAction, Math.floor(Date.now()));
    }

    public endDurationEvent(eventCategory: string,
                            eventAction: string,
                            eventLabel:string): void {
        let duration = Math.floor(((Date.now()) - this.timings.get(eventCategory + eventAction)));
        this.emitTiming(eventCategory, eventAction, eventLabel, duration);
        this.timings.delete(eventCategory + eventAction);
    }
}
